import React from "react";
import {ListItem, SectionHeading, SectionHeadingRef} from "../PromotionsText";

type Props = { headingRef: SectionHeadingRef };

const PromotionPeriodsSection = ({headingRef}: Props) => (
  <>
    <SectionHeading headingRef={headingRef}>Promotions and Promotion Periods</SectionHeading>

    <ListItem marker="(a)">
      {"We may, from time-to-time, run Promotions and these may take the form of bonus offers (whether Bonus, Free Play, Risk Free, and/or Deposit Match), or other form of Promotion, or a combination of any of these. The particular form of Promotion will be described, and full details set out, in the communications (such as emails, computer pop-ups and letters) We issue to tell You about each Promotion (each a “Promotion Communication”) and/or on the individual web landing page for the relevant Promotion."}
    </ListItem>

    <ListItem marker="(b)">
      {"For the purposes of all Promotions, the promoter is the entity You have contracted with under the General Terms."}
    </ListItem>

    <ListItem marker="(c)" withBottomMargin>
      {"The period of time during which each Promotion will run (“Promotion Period”) will be specified in the applicable Key Terms. Each Promotion will automatically close at the end of the relevant Promotion Period, at which point no further participation in that Promotion will be possible. Where no Promotion Period is specified the relevant Promotion will end when it is discontinued on the Platform."}
    </ListItem>
  </>
);

export default PromotionPeriodsSection;
